/* eslint-disable no-open-modules-imports */

import { ZDFDemoFeature } from 'demo/zdf/componentdemozdf';
import type { FeatureGroup } from 'feature/feature-helpers';
import { SECTION } from 'feature/feature-helpers';
import { OpenLinksInNewTabFeature } from 'feature/general/open-links-in-new-tab';
import { t } from 'util/stdtypes';

export const componentDemoFeatures: FeatureGroup[] = [
    SECTION(t('Core Component Sets'), [ZDFDemoFeature]),
    SECTION(t('Configuration'), [OpenLinksInNewTabFeature]),
];

export const componentDemoDefaultConfig = {
    demo_designsystem: true,
    demo_comment: true,
    demo_profile: true,
    demo_eventlog: true,
    demo_profileedit: true,
    demo_admin: true,
    demo_topbar: true,
    demo_basicfeatures: true,
    demo_embedded: true,
    demo_login: true,
    demo_help: true,
    demo_profile_delete: true,
    demo_profileanswers: true,
    demo_poll: true,
    demo_survey: true,
    demo_puppet: true,
    demo_questionbasics: true,
    demo_cbcrc: true,
    demo_zdf: true,
    demo_conversation: true,
    demo_teaser: true,
    demo_fallbacks: true,
    demo_moderationdash: true,
    demo_moderation: true,
    demo_topic: true,
    demo_topic_config: true,
};
